import type { CrowdexUIMessage } from '@crowdex/agent-contracts';
import type { DynamicToolPart } from './types';

const QUESTION_ANSWER_KEY = '__crowdexAnswer';

export function questionAnswer(part: DynamicToolPart): string | null {
  if (typeof part.input !== 'object' || part.input === null || Array.isArray(part.input))
    return null;
  const answer = (part.input as Record<string, unknown>)[QUESTION_ANSWER_KEY];
  return typeof answer === 'string' && answer.trim().length > 0 ? answer.trim() : null;
}

/** Persist the UI answer beside the tool input because some agents complete with `output: null`. */
export function recordQuestionAnswer(
  messages: readonly CrowdexUIMessage[],
  toolCallId: string,
  answer: string,
): CrowdexUIMessage[] {
  const value = answer.trim();
  if (value.length === 0) return messages as CrowdexUIMessage[];
  let changed = false;
  const next = messages.map((message) => {
    let messageChanged = false;
    const parts = message.parts.map((part) => {
      if (part.type !== 'dynamic-tool' || part.toolCallId !== toolCallId) return part;
      const input =
        typeof part.input === 'object' && part.input !== null && !Array.isArray(part.input)
          ? part.input
          : {};
      if ((input as Record<string, unknown>)[QUESTION_ANSWER_KEY] === value) return part;
      changed = true;
      messageChanged = true;
      return { ...part, input: { ...input, [QUESTION_ANSWER_KEY]: value } };
    });
    return messageChanged ? { ...message, parts } : message;
  });
  return changed ? next : (messages as CrowdexUIMessage[]);
}
